// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { portalSettingInitialState } from '../store/initialState';
import { clone } from './helper';
import { combineReducers } from 'redux';
import {
  GET_VIDEO_CALL_QUALITY_PROFILES,
  GOT_VIDEO_CALL_QUALITY_PROFILES,
  SET_ALL_PORTAL_SETTINGS,
  SET_SELECTED_PORTAL_VALUE,
  PORTAL_SETTING_LOADER,
  REFETCH_PORTAL_SETTING_INDICATOR,
  ERROR_GETTING_VIDEO_CALL_QUALITY_PROFILES,
} from '../actions/portalSetting';

const reducer = (state = portalSettingInitialState, action) => {
  switch (action.type) {
    case GET_VIDEO_CALL_QUALITY_PROFILES:
      var copy = clone(state);
      copy.videoQualityProfile.videoCallQualityProfileFetching = true;
      return objectAssign({}, state, {
        videoQualityProfile: copy.videoQualityProfile,
      });
    // Set the portal settings
    case SET_ALL_PORTAL_SETTINGS:
      return objectAssign({}, state, {
        portalSettings: action.data,
      });
    // Set the selected portal settings
    case SET_SELECTED_PORTAL_VALUE:
      return objectAssign({}, state, {
        selectedPortalSettingValue: action.data,
      });
    // Set the portal setting loader
    case PORTAL_SETTING_LOADER:
      return objectAssign({}, state, {
        portalSettingLoader: action.data,
      });

    case GOT_VIDEO_CALL_QUALITY_PROFILES:
      if (action.data) {
        var copy = clone(state.videoQualityProfile);
        copy.videoCallQualityProfileFetching = false;
        let callQualityOptionsArray = [];
        var entry;
        for (entry in action.data.videoCallQualityProfiles) {
          let pushEntry = {
            value: action.data.videoCallQualityProfiles[entry].id.toString(),
            text: action.data.videoCallQualityProfiles[entry].description,
          };
          callQualityOptionsArray.push(pushEntry);
        }
        copy.callQualityOptions = callQualityOptionsArray;
        copy.defaultVideoCallQuality = action.data.defaultVideoCallQuality;

        return objectAssign({}, state, {
          videoQualityProfile: copy,
          //need to verify if i assign action.data it will not overwrite other properties of portal setting
        });
      }
      return objectAssign({}, state, { videoQualityProfile: {} });
    default:
      return state;
  }
};

export default reducer;
